import { Box } from "native-base";

export const CalculatorFormStackWrapper = ({ children }) => (
  <Box bg="graysecondary.100" p={6}>
    {children}
  </Box>
);
